module.exports = __webpack_public_path__ + "band_0.9591c410.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_0.png
// module id = 4orv
// module chunks = 0